import React from "react";
import "./styles/TzBrandMark.css";

type Props = {
  className?: string;
  size?: number;
};

/** Marca TZ modernizada: mismos colores (naranja / menta / navy) con animación de capas. */
const TzBrandMark: React.FC<Props> = ({ className = "", size = 112 }) => {
  return (
    <div
      className={`tz-brand-mark ${className}`.trim()}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <div className="tz-brand-mark-halo" />
      <svg
        className="tz-brand-mark-svg"
        viewBox="0 0 200 160"
        role="img"
        aria-label="Transportes Zepeda"
      >
        <defs>
          <linearGradient id="tzMint" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#9FE8C8" />
            <stop offset="100%" stopColor="#6ED4B0" />
          </linearGradient>
          <linearGradient id="tzOrange" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FF9A3D" />
            <stop offset="55%" stopColor="#F97316" />
            <stop offset="100%" stopColor="#EA580C" />
          </linearGradient>
          <linearGradient id="tzNavy" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#1E3A5F" />
            <stop offset="100%" stopColor="#0F2744" />
          </linearGradient>
          <filter id="tzSoftShadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="6" stdDeviation="6" floodColor="#0F2744" floodOpacity="0.22" />
          </filter>
        </defs>

        {/* Capa menta (offset) */}
        <ellipse
          className="tz-brand-layer tz-brand-layer--mint"
          cx="112"
          cy="86"
          rx="78"
          ry="48"
          fill="url(#tzMint)"
        />

        {/* Capa naranja principal */}
        <ellipse
          className="tz-brand-layer tz-brand-layer--orange"
          cx="100"
          cy="78"
          rx="78"
          ry="48"
          fill="url(#tzOrange)"
          filter="url(#tzSoftShadow)"
        />

        {/* Brillo sutil */}
        <ellipse
          className="tz-brand-shine"
          cx="78"
          cy="58"
          rx="42"
          ry="16"
          fill="rgba(255,255,255,0.22)"
        />

        {/* Letras TZ */}
        <g className="tz-brand-letters">
          <text
            x="100"
            y="92"
            textAnchor="middle"
            fontFamily="'Segoe UI', 'Helvetica Neue', Arial, sans-serif"
            fontWeight="800"
            fontSize="58"
            letterSpacing="-2"
            fill="url(#tzNavy)"
          >
            TZ
          </text>
        </g>
      </svg>
    </div>
  );
};

export default TzBrandMark;
